'use client';

import HeaderLayout from '@components/pages/common/HeaderLayoutContainer';
import DesktopHeaderLayoutContainer from '@components/pages/common/DesktopHeaderLayoutContainer';
import { useLoading } from '@contexts/LoadingContext';
import { useScrollRestoration } from '@hooks/restoreScrollPosition';
import useAirBridgeEvent from '@hooks/useAirBridgeEvent';
import useSpcScrollPin from '@hooks/spc/useSpcScrollPin';
import useGlobalState from '@hooks/useGlobalState';
import { SpcPageServerProps } from '@models/spc';
import React, { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import useSpcNavigationModule from '@hooks/spc/useSpcNavigationModule';
import { getSpcHeaderTitle } from '@utils/spcUtils';

const SpcPageContent = React.lazy(() => import('../SpcPageContent'));

interface SpcPageContainerProps {
  spcType: string;
}

function SpcPageContainer({ spcType }: SpcPageContainerProps) {
  const { isMobile, initialData } = useGlobalState<SpcPageServerProps>();
  const { isAllLoaded } = useLoading(['spcConnerList', 'spcProductList']);
  useScrollRestoration(isAllLoaded);
  const searchParams = useSearchParams();
  const { openAirBridgeAppBanner } = useAirBridgeEvent();
  const {
    items: navigationItems,
    hasNavigation,
    isNavigationResolved,
  } = useSpcNavigationModule({
    spcType,
  });
  const pageTitle = getSpcHeaderTitle(
    spcType,
    hasNavigation,
    isNavigationResolved
  );
  const pageClassName = 'specialty-page';
  const gnbType = searchParams?.get('gnbType') || 'N';

  useSpcScrollPin({ gnbType, isDesktop: !isMobile });

  useEffect(() => {
    openAirBridgeAppBanner();
  }, [openAirBridgeAppBanner]);

  return !isMobile ? (
    <DesktopHeaderLayoutContainer
      className={pageClassName}
      pageTitle={pageTitle}
      megaMenu={initialData?.megaMenu}
      gnbInfo={initialData?.gnbInfo || []}
      searchInitInfo={initialData?.searchInitInfo}
    >
      <SpcPageContent
        spcType={spcType}
        navigationItems={navigationItems}
        hasNavigation={hasNavigation}
      />
    </DesktopHeaderLayoutContainer>
  ) : (
    <HeaderLayout
      gnbType={gnbType}
      className={pageClassName}
      subHeaderType="subDetail"
      transparentHeader
      isFooter={false}
      logoInfo={initialData?.logoInfo?.biLogo}
      gnbInfo={initialData?.gnbInfo}
      pageTitle={pageTitle}
      selectedGnbValue="/rn/spc/"
      isProfileBtn={false}
    >
      <SpcPageContent
        spcType={spcType}
        navigationItems={navigationItems}
        hasNavigation={hasNavigation}
      />
    </HeaderLayout>
  );
}

export default SpcPageContainer;
